/**
 * "Plan for" helpers for the frontend. A post or schedule is delegated to me
 * when one of its schedules publishes on my account. Settings expose the user
 * by username (no id), so that is the key we compare on.
 */
export const currentUsername = (settings) => settings?.user?.username ?? null;

export const scheduleIsForMe = (schedule, username) =>
  Boolean(username && schedule?.publish_as && schedule.publish_as.username === username);

/** The schedule of `post` that publishes on my account, or null. */
export const delegatedScheduleFor = (post, username) =>
  (post?.schedules ?? []).find((s) => scheduleIsForMe(s, username)) ?? null;

export const isDelegatedToMe = (post, username) => delegatedScheduleFor(post, username) !== null;

export const personName = (p) => (p?.name && p.name.trim()) || p?.username || "";
